<audio id="audio-recording-playback-player" [src]="audioSrc" type="audio/wav"></audio>
<div class="audio-recording-playback-container">

  <!-- Form input field to change audio recording name -->
  <div class="audio-recording-playback-title-container">
    <label for="audioRecordingFileName">
      {{ 'audio.playback.fileName' | transloco }}
    </label>
    <input class="audio-recording-playback-file-name" type="text" [(ngModel)]="fileName"
      placeholder="{{ 'audio.playback.inputPlaceholder' | transloco }}" focus-if="true" maxlength="30"
      ng-model="accountSettingsCtrl.account.firstName" name="audioRecordingFileName"
      id="audioRecordingFileName" />
  </div>

  <!-- Audio recording exceeded alert: -->
  <p *ngIf="exceededRecordingLimit" class="audio-exceeded-recording-limit" transloco="audio.recording.exceeded">
    Recording reached {{ audioRecordingTimeDifference }} hour time limit and was stopped.
  </p>

  <!-- Custom Audio player -->
  <div class="bulb-playback-audio-player">
    <div class="bulb-playback-audio-controls">
      <i class="fa fa-play bulb-playback-audio-play"></i>
      <span class="bulb-playback-audio-start-time">00:00</span>
      <div class="bulb-playback-audio-progressbar"></div>
      <span class="time">00:00</span>
      <i class="bulb-playback-audio-mute fa fa-volume-up"></i>
      <div class="bulb-playback-audio-volume"></div>
    </div>
  </div>

  <div class="audio-recording-playback-footer">
    <span class="audio-recording-delete" (click)="deleteAudioRecording();">
      <p *ngIf="!isMobile" transloco="audio.recording.delete">Delete</p>
    </span>
    <span class="audio-recording-download" (click)="downloadRecordedAudio();">
      <p *ngIf="!isMobile" transloco="audio.recording.download">Download</p>
    </span>
    <span class="audio-recording-save audio-recording-able-to-save" (click)="saveRecording();">
      <p *ngIf="!isMobile" transloco="audio.recording.save">Save</p>
    </span>
  </div>

</div>